function r(a, e) {
  for (var n = a < 0 ? "-" : "", t = Math.abs(a).toString(); t.length < e; )
    t = "0" + t;
  return n + t;
}
export {
  r as default
};
